export default __webpack_public_path__ + "static/media/icon-stretcher.a636cd38.svg";